import i18n from '@/utils/i18n';
import React from 'react';
import { BlurView } from 'expo-blur';
import { Button } from '@/components/button';
import { createStyles } from '@/contexts/theme-context';
import { InputAccessoryViewSafe } from '@/components/input-accessory-view-safe';
import { View } from 'react-native';

interface Props {
  cancelChange: () => void;
  confirmChange: () => void;
  customInputAccessoryViewID: string | undefined;
  isConfirming: boolean;
}

export const ResetAndSaveButtons: React.FC<Props> = ({
  cancelChange,
  confirmChange,
  customInputAccessoryViewID,
  isConfirming,
}) => {
  const [styles] = useStyles();
  return (
    <InputAccessoryViewSafe nativeID={customInputAccessoryViewID}>
      <BlurView>
        <View pointerEvents="box-none" style={styles.container}>
          <Button
            containerStyle={styles.flex}
            disabled={isConfirming}
            onPress={cancelChange}
            size="medium"
            testID="price-override-reset-button"
            trackingData={{ name: 'price_override_input.reset_button' }}
            type="tertiary"
          >
            {i18n.t('reset')}
          </Button>
          <Button
            containerStyle={styles.flex}
            loading={isConfirming}
            onPress={confirmChange}
            size="medium"
            testID="price-override-confirm-button"
            trackingData={{ name: 'price_override_input.confirm_button' }}
            type="primary"
          >
            {i18n.t('save')}
          </Button>
        </View>
      </BlurView>
    </InputAccessoryViewSafe>
  );
};

const useStyles = createStyles(() => ({
  container: {
    flexDirection: 'row',
    gap: 8,
    justifyContent: 'space-between',
    padding: 8,
    width: '100%',
  },
  flex: {
    flex: 1,
  },
}));
